import { MainAppService } from "src/modules/app-template/services/main-app.service";

export enum NetworkLinkedDocumentShareType {
    //netgen start
    private = 0,
    public = 1,
    certain = 2
    //netgen end
}
export namespace NetworkLinkedDocumentShareType{
    export function getName(value: NetworkLinkedDocumentShareType): string {
        switch (value) {
            case NetworkLinkedDocumentShareType.private:
                return "private";
            case NetworkLinkedDocumentShareType.public:
                return "public";
            case NetworkLinkedDocumentShareType.certain:
                return "certain";
            default:
                return "???";
        }
    }

    export function getDisplayName(value: NetworkLinkedDocumentShareType, app: MainAppService): string {
        return app.t("entity.NetworkLinkedDocumentShareType." + getName(value));
    }
}
